@app.controller 'ComponentEditController', ($scope, ComponentService, $stateParams) ->

  ComponentService.show {id: $stateParams.id}, ((data) =>
    @type = data.componentType
    @name = data.name
    @meta = data.meta
    _.defaults  @meta,
      experiment:
        variationCount: 2
    @parentType = data.componentParentType
    @parentId = data.componentParentId
    @position = data.position
  ), ((error) =>
    @showNewButton = true
  )

  this
